import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
//import Utils from '../../../../util';
import {API} from "../../../../config";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

//const moment = require('moment');

const investorUploads = API.service('investors-uploaded-files');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        //border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class DepositProof extends Component {
    state={
        extension:'',
        data:{}
    }

    populatedrawer = () => {
        let content = (<div style={{marginBottom:10}}>
            {(this.state.extension[0] === 'pdf' || this.state.extension[0]  === 'PDF') &&
            <iframe src={this.photograph} title={this.photograph} width={'400px'} height={'600px'} />
            }
            {(this.state.extension[0] !== 'pdf' && this.state.extension[0] !== 'PDF') &&
            <img src={this.photograph} alt={'kyc'} width={400}/>
            }
        </div>);

        this.props.context.update({
            drawerContent: content,
            drawerWidth:400,
            drawerHeight:600
        })
    }

    componentDidMount() {
        investorUploads.find({query:{_account:this.props.investor._account, _fieldname:'_deposit_proof'+this.props.depId}}).then(s=>{
            if(s.total > 0) {
                let extension = (/[.]/.exec(s.data[0]._orig_filename)) ? /[^.]+$/.exec(s.data[0]._orig_filename) : undefined;

                this.photograph = s.data[0]._orig_filename;
                this.setState({
                    extension: extension,
                    data:s.data[0]
                })
            }
        })
    }

    render() {
        return (
            <React.Fragment>
                {(this.photograph) &&
                    <button onClick={this.populatedrawer}><FontAwesomeIcon icon={"file-alt"}/></button>
                }

                {!(this.photograph) &&
                    <span></span>
                }
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(DepositProof)));
